<script>
import { hasDeepValue, has } from "has-deep-value";
import moment from "moment";
export default {
  data() {
    return {
      APPLICATION_NAME: "meritios",
    };
  },
  methods: {
    moment,
    hasDeepValue,
    $logoutUserAndSaveCurrentPath() {
      let vm = this;
      vm.$localStorage.set("redirect_path", vm.$route.path);
      vm.$logOut();
    },
    $redirectLoggedUser(defaultPath) {
      let vm = this;
      if (vm.$localStorage.get("redirect_path")) {
        vm.$router.push({
          path: vm.$localStorage.get("redirect_path"),
        });
        vm.$localStorage.remove("redirect_path");
      } else {
        vm.$router.push(defaultPath);
      }
    },
    $logOut(canRedirect = true) {
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
      this.$localStorage.remove("logged_user_data");
      if (canRedirect) {
        this.$router.push({ name: "login" });
      }
    },
    $nameInitials(name) {
      var initials = name.match(/\b\w/g) || [];
      initials = (
        (initials.shift() || "") + (initials.pop() || "")
      ).toUpperCase();
      return initials;
    },
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
    $makeId(length) {
      var result = "";
      var characters =
        "dshsjkssdkljdsjsklndsndslksddsjndskjnjsaabcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    $formatMoney(amount, decimalCount = 0, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
            : "")
        );
      } catch (e) {
        console.log(e);
      }
    },
    $fetchFromObject(obj, prop) {
      let vm = this;
      if (typeof obj === "undefined") return false;
      var _index = prop.indexOf(".");
      if (_index > -1) {
        return vm.$fetchFromObject(
          obj[prop.substring(0, _index)],
          prop.substr(_index + 1)
        );
      }
      if (obj[prop] && obj[prop] != "null" && obj[prop] != "") {
        return true;
      } else {
        return false;
      }
    },
    $hasKey(obj, keyString) {
      let vm = this;
      if (vm.hasDeepValue(obj, keyString)) {
        if (vm.$fetchFromObject(obj, keyString)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    $dateObj(date) {
      let vm = this;
      if (date && date != "null" && date != "") {
        let yyy = vm.moment(date).format("YYYY");
        let mm = vm.moment(date).format("MM");
        let dd = vm.moment(date).format("DD");
        return new Date(yyy, mm, dd);
      } else {
        return new Date();
      }
    },
    $isFieldsValidated(form, rules, length = 10000) {
      let vm = this;
      let is_error = false;
      Object.keys(rules).forEach((key, index) => {
        if (index < length - 1) {
          if (rules[key].run(form[key])) {
            let error_message = rules[key].run(form[key]);
            if (error_message) {
              if (!is_error) {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "Something wrong",
                  text: error_message,
                });
              }
              is_error = true;
            }
          }
        }
      });
      return !is_error;
    },
    validateMessageTime(date) {
      let vm = this;
      return vm.moment(date).calendar({
        sameDay: "[Today], HH:mm",
        nextDay: "[Tomorrow], HH:mm",
        nextWeek: "dddd",
        lastDay: "[Yesterday], HH:mm",
        lastWeek: "MMM, D YYYY",
        sameElse: "MMM, D YYYY",
      });
    },
    getCurrentBrowser() {
      var browser = (function () {
        var test = function (regexp) {
          return regexp.test(window.navigator.userAgent);
        };
        switch (true) {
          case test(/edg/i):
            return "Microsoft Edge";
          case test(/trident/i):
            return "Microsoft Internet Explorer";
          case test(/firefox|fxios/i):
            return "Mozilla Firefox";
          case test(/opr\//i):
            return "Opera";
          case test(/ucbrowser/i):
            return "UC Browser";
          case test(/samsungbrowser/i):
            return "Samsung Browser";
          case test(/chrome|chromium|crios/i):
            return "Google Chrome";
          case test(/safari/i):
            return "Apple Safari";
          default:
            return "Other";
        }
      })();
      return browser;
    },
    $htmlToText(html) {
      var temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent;
    },
    htmlToText(html) {
      var temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent;
    },
    $getLoggedUser() {
      let vm = this;
      if (vm.$localStorage.get("logged_user_data")) {
        let user_data = JSON.parse(vm.$localStorage.get("logged_user_data"));
        return user_data;
      } else {
        return null;
      }
    },
  },
};
</script>